export default __webpack_public_path__ + "static/media/vaccineIllustration2.db538afa.gif";